import React from 'react';
import heroimg from './../../assets/img/qoutehero.png'
const Hero = () => {
  return (
    <section id="hero" className="d-flex justify-content-center align-items-center">
      <div className="container position-relative" data-aos="zoom-in" data-aos-delay="100">
       
    <div className="container" data-aos="fade-up">
      <div className="row margint">
        <div className="col-lg-6 order-2 order-lg-1 bordert" data-aos="fade-left" data-aos-delay="100">
          <div className="center ">
          <h1 id='yellow' className='sideline marginline blue'>Your Network, 
          <a className='worth'>
Your &nbsp;<span class="typewriter"></span>
</a></h1>

          </div>
{/* <div>          */}
         {/* <a href='/Homedubu' className='center'><button className='btn-get-started'>Dubu</button></a></div> */}
        </div>
        <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
         
          {/* <p className='center' id='yellow'>The Power of Your Connections</p> */}
          <p className="fst-italic center">
       
            
          <div className="center heroimg">
            
            <img width="px" className="heroimg"  src={heroimg}  alt="" />
         
          </div>
          </p>
        </div>
      </div>
    </div>
    <div className="center">
      <hr style={{ width: '20%', color: 'black', marginTop: '80px', boxShadow: '#021509' }} />
    </div>
        
      </div>
    </section>
  );
};

export default Hero;
